export enum InfectiousSources {
    NormalResult = 1,
    CultureResult = 2,
    Doctor = 3,
}
